import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useLanguage, Language } from "@/contexts/LanguageContext";
import { useTheme } from "next-themes";

/**
 * Syncs the user's stored language and theme preferences from their profile
 * to the app's language/theme context on login.
 * Skips syncing on shop pages when a ?lang param is present.
 */
const LanguageSync = () => {
  const { profile } = useAuth();
  const { setLanguage } = useLanguage();
  const { setTheme } = useTheme();
  const location = useLocation();

  useEffect(() => {
    // Don't override language on shop pages if ?lang query param is set
    if (location.pathname.startsWith("/shop/")) {
      const params = new URLSearchParams(location.search);
      if (params.get("lang")) return;
    }

    if (profile?.language) {
      const supported: Language[] = ["en", "nl", "fr", "de"];
      if (supported.includes(profile.language as Language)) {
        setLanguage(profile.language as Language);
      }
    }

    if (profile?.theme) {
      setTheme(profile.theme);
    }
  }, [profile?.language, profile?.theme, setLanguage, setTheme, location.pathname, location.search]);

  return null;
};

export default LanguageSync;
